import React, { useState, useEffect } from "react";
import {
  Modal,
  Tabs,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  Button,
  Row,
  Col,
  message,
  Typography,
  Divider,
  Space,
  InputNumber
} from "antd";
import dayjs from "dayjs";
import { Method_POST_CONTEXTO } from "../../../../../service/api";
import { NumericFormat } from "react-number-format";
import {
  SaveOutlined,
  ArrowLeftOutlined,
  UploadOutlined,
  DollarOutlined,
  CalendarOutlined,
  FileTextOutlined,
  InboxOutlined
} from '@ant-design/icons';
const { Title, Text } = Typography;

const { TabPane } = Tabs;
const { Option } = Select;

export function ModalLancamento({ open, onClose, tipo }) {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [contas, setContas] = useState([]);
  const [loadingContas, setLoadingContas] = useState(false);

  useEffect(() => {
    if (open && tipo) {
      Method_POST_CONTEXTO("/contabil/lancamento/categoria/grupo/listar", {
        tipo: { id: tipo },
      })
        .then((res) => setGrupos(res || []))
        .catch(() => message.error("Erro ao buscar grupos"));
    }
  }, [open, tipo]);

  useEffect(() => {
    if (open) {
      setLoadingContas(true);
      Method_POST_CONTEXTO("/cliente/conta-bancaria/listar")
        .then((res) => setContas(Array.isArray(res) ? res : []))
        .catch(() => message.error("Erro ao carregar contas do cliente"))
        .finally(() => setLoadingContas(false));
    }
  }, [open]);

  const handleGrupoChange = (grupoId) => {
    if (!grupoId) {
      setCategorias([]);
      form.setFieldsValue({ categoria: null });
      return;
    }

    Method_POST_CONTEXTO("/contabil/lancamento/categoria/listar", {
      grupo: { id: grupoId },
      situacao: { id: "A" },
    })
      .then((res) => setCategorias(res || []))
      .catch(() => message.error("Erro ao buscar categorias"));

    form.setFieldsValue({ categoria: null });
  };

  const handleUploadChange = ({ fileList }) => setFileList(fileList);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          id: "",
          cliente: { id: "" },
          categoria: { id: values.categoria },
          tipo: { id: tipo },
          contaBancaria: { id: values.contaBancaria || "0" },
          dataReferencia: values.dataReferencia
            ? values.dataReferencia.toISOString()
            : null,
          descricao: values.descricao || "",
          situacao: { id: values.situacao },
          valor: values.valor?.toString() || "0.00",
        };

        Method_POST_CONTEXTO("contabil/lancamento/cadastrar", payload)
          .then((res) => {
            message.success("Lançamento cadastrado com sucesso!");
            if (res?.id) {
              uploadArquivo(res.id);
            }
            onClose?.();
            form.resetFields();
            setFileList([]);
          })
          .catch(() => {
            message.error("Erro ao cadastrar lançamento");
          });
      })
      .catch((info) => console.log("Validation Failed:", info));
  };

  const uploadArquivo = async (lancamentoId) => {
    if (!fileList.length) {
      message.warning("Selecione um arquivo antes de enviar");
      return;
    }

    const formData = new FormData();
    fileList.forEach(file => {
      formData.append("file", file.originFileObj);
    });

    try {
      await Method_POST_CONTEXTO(
        `contabil/lancamento/arquivo/upload?id=${lancamentoId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      message.success("Arquivo enviado com sucesso!");
    } catch (error) {
      message.error("Erro ao enviar arquivo");
    }
  };


  const accentColor = tipo === 'C' ? '#059669' : '#e11d48';
  const bgColor = tipo === 'C' ? '#ecfdf5' : '#fff1f2';
  const isCredit = tipo === 'C';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={1000}
      style={{ top: 20 }}
      className="premium-modal-v2"
      destroyOnClose
      closable={true}
    >
      <div style={{ padding: '8px' }}>
        <header style={{
          marginBottom: 32,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          borderBottom: '1px solid #f1f5f9',
          paddingBottom: 20
        }}>
          <div style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: accentColor,
            fontSize: 24,
            boxShadow: `0 4px 12px ${accentColor}20`
          }}>
            {isCredit ? <DollarOutlined /> : <FileTextOutlined />}
          </div>
          <div>
            <Title level={4} style={{ margin: 0, color: '#0f172a' }}>
              Novo {isCredit ? 'Recebimento' : 'Pagamento'}
            </Title>
            <Text type="secondary">Preencha as informações financeiras abaixo para a conciliação bancária.</Text>
          </div>
        </header>

        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          initialValues={{ situacao: 'L', dataReferencia: dayjs() }}
        >
          <Row gutter={[24, 0]}>
            <Col xs={24} md={8}>
              <Form.Item
                name="grupo"
                label={<Space><CalendarOutlined /> Grupo de Lançamento</Space>}
                rules={[{ required: true, message: 'Obrigatório' }]}
              >
                <Select
                  size="large"
                  className="premium-select"
                  placeholder="Selecione o grupo"
                  onChange={(val) => handleGrupoChange(val)}
                >
                  {grupos.map(g => (
                    <Option key={g.id} value={g.id}>{g.nome}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="categoria"
                label={<Space><FileTextOutlined /> Categoria / Conta</Space>}
                rules={[{ required: true, message: 'Obrigatório' }]}
              >
                <Select
                  size="large"
                  className="premium-select"
                  placeholder="Selecione a categoria"
                  disabled={!categorias.length}
                >
                  {categorias.map(c => (
                    <Option key={c.id} value={c.id}>{c.nome}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="contaBancaria"
                label={<Space><DollarOutlined /> Conta Bancária</Space>}
                rules={[{ required: true, message: 'Obrigatório' }]}
              >
                <Select size="large" className="premium-select" loading={loadingContas} placeholder="Selecione">
                  <Option value="0">000 - Dinheiro (Caixa)</Option>
                  {contas.map(acc => (
                    <Option key={acc.id} value={acc.id}>
                      {acc.nome || acc.banco?.nome} - Ag: {acc.agencia} CC: {acc.conta}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 0]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name="dataReferencia"
                label="Data de Referência"
                rules={[{ required: true, message: 'Obrigatório' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format={["DD/MM/YYYY", "DDMMYYYY"]}
                  size="large"
                  className="premium-datepicker"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name="valor"
                label="Valor do Lançamento"
                rules={[{ required: true, message: 'Obrigatório' }]}
              >
                <NumericFormat
                  customInput={Input}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="R$ "
                  style={{ width: '100%' }}
                  className="premium-input-number"
                  size="large"
                  placeholder="0,00"
                  decimalScale={2}
                  fixedDecimalScale
                  value={form.getFieldValue("valor")}
                  onValueChange={(values) =>
                    form.setFieldsValue({ valor: values.floatValue ?? 0 })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="situacao"
                label="Situação Atual"
                rules={[{ required: true }]}
              >
                <Select size="large" className="premium-select">
                  <Option value="A">Aberto</Option>
                  <Option value="L">Liquidado</Option>
                  <Option value="C">Cancelado</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="descricao"
            label="Descrição / Histórico"
            rules={[{ required: true, message: 'Descreva o lançamento' }]}
          >
            <Input.TextArea rows={2} placeholder="Ex: Pagamento referente a nota fiscal #123..." className="premium-textarea" />
          </Form.Item>

          <div style={{ marginTop: 24, marginBottom: 24 }}>
            <Divider orientation="left"><Text strong style={{ color: '#475569' }}>Documentos e Comprovantes (Opcional)</Text></Divider>

            <Row gutter={24}>
              <Col xs={24}>
                <Upload.Dragger
                  maxCount={1}
                  beforeUpload={() => false}
                  fileList={fileList}
                  onChange={handleUploadChange}
                  className="premium-upload-dragger"
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: '#005A9E' }} />
                  </p>
                  <p className="ant-upload-text">Clique ou arraste comprovantes aqui</p>
                </Upload.Dragger>
              </Col>
            </Row>
          </div>



          <div
            className="footer-buttons"
            style={{
              marginTop: 40,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 12,
              paddingTop: 24,
              borderTop: '1px solid #f1f5f9',
              flexWrap: 'wrap'
            }}
          >
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={onClose}
              size="large"
              className="premium-btn-secondary"
            >
              Voltar
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              onClick={handleSave}
              size="large"
              className="premium-btn-primary"
            >
              Realizar Lançamento
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
